import CurrentUserService from '@/services/currentUserService';
import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router';
import Home from '../views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '',
    redirect: { name: '/' },
  },
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/', // 子路由前不需要加斜杠 /
        name: '/',
        component: () => import(/* webpackChunkName: "user" */ '../views/Workbench.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'resource',
        name: 'resource',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Resource.vue'),
        meta: { requiresAuth: true, accessCode: 'ServiceConfigLink' },
        props: true,
      }, {
        path: 'customer',
        name: 'customer',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Customer.vue'),
        meta: { requiresAuth: true, accessCode: 'CustomerLink' },
        props: true,
      }, {
        path: 'role',
        name: 'role',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Role.vue'),
        meta: { requiresAuth: true, accessCode: 'RoleLink' },
        props: true,
      }, {
        path: 'userinfo',
        name: 'userinfo',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/UserInfo.vue'),
        meta: { requiresAuth: true, accessCode: 'UserInfoLink' },
        props: true,
      }, {
        path: 'userinfo/:id',
        name: 'userinfodetail',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/UserInfoDetail.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'role/:id',
        name: 'roledetail',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/RoleDetail.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'customer/:id',
        name: 'customerdetail',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/CustomerDetail.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'modifyPassword',
        name: 'modifyPassword',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/ModifyPassword.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'personal',
        name: 'personal',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Personal.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'application',
        name: 'application',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/Application.vue'),
        meta: { requiresAuth: true, accessCode: 'ApplicationLink' },
        props: true
      },{
        path: 'AddApplication',
        name: 'AddApplication',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "about" */ '../views/AddApplication.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
      }, {
        path: 'application/:appId',
        name: 'applicationManage',
        component: () => import(/* webpackChunkName: "about" */ '../views/applications/ApplicationManage.vue'),
        meta: { requiresAuth: true, accessCode: '' },
        props: true,
        children: [
          {
            path: 'imuser', // 子路由前不需要加斜杠 /
            name: 'imuser',
            component: () => import(/* webpackChunkName: "user" */ '../views/applications/IMUser.vue'),
            meta: { requiresAuth: true, accessCode: '' },
            props: true,
          }, {
            path: 'imuser/:userId',
            name: 'imuserdetail',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ '../views/applications/IMUserDetail.vue'),
            meta: { requiresAuth: true, accessCode: '' },
            props: true,
          }, {
            path: 'applicationDetail',
            name: 'applicationDetail',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ '../views/applications/ApplicationDetail.vue'),
            meta: { requiresAuth: true, accessCode: '' },
            props: true,
          },
          {
            path: 'appConfiguration',
            name: 'appConfiguration',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ '../views/applications/appConfiguration.vue'),
            meta: { requiresAuth: true, accessCode: '' },
            props: true,
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue'),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 登录之前做一个判断 ,判断它进入其它页面有没有先登录,
router.beforeEach((to, from, next) => {
  const { requiresAuth, accessCode } = to.meta;
  // 判断有没有登录
  const isLogin = sessionStorage.imToken;
  const userInfo = CurrentUserService.GetUserInfo();
  if (requiresAuth) { // 若目标路由需要认证
    if (!isLogin) {
      next({ path: '/login', query: { redirect: to.fullPath } });
    } else if (userInfo.role.includes(String(accessCode)) || String(accessCode).length === 0) {
      next();
    }
  } else {
    next();
  }
  // 如果当前访问的是登录页面或者注册页面可以让它进入
  // if (to.path === '/login' || isLogin) { // 如果是进入login 或已经登录,则正常进入
  //   next();
  // } else {
  //   // 否则就让他进入登录页面
  //   next('/login');
  // }
});
export default router;
